// deps
import React from "react";

// internal deps
import { HalfCard } from "@swiggy-private/dls-web-core/dist/components/HalfCard";
import { GROUP_CART_ORDER_DATA_TEST_IDS } from "@swiggy-private/cart-test-ids";
import { FullWidthButton } from "@swiggy-private/dls-web-core/dist/components/FullWidthButton";

// styles
import { GroupCartBottomSheetContainer, TitleText, SubtitleText } from "./styles";

// constants
import { GO_BACK_CTA_TEXT } from "@cart-ui/constants/GroupCart";

interface GroupCartBottomSheetInfoProps {
    title: string;
    subText: string;
    onBackEvent: VoidFunction;
}

const GroupCartBottomSheetInfo = ({ title, subText, onBackEvent }: GroupCartBottomSheetInfoProps) => {
    return (
        <HalfCard
            onClose={onBackEvent}
            isOpen
            data-testid={GROUP_CART_ORDER_DATA_TEST_IDS.BOTTOMSHEET}
            closeOnOverlayClick={false}
        >
            <GroupCartBottomSheetContainer>
                <TitleText variant="V2.heading1.neutral.bold" color="text_Highest_Emphasis">
                    {title}
                </TitleText>

                <SubtitleText variant="V2.body1.neutral.regular" color="text_High_Emphasis">
                    {subText}
                </SubtitleText>

                <FullWidthButton
                    variant="primary"
                    onClick={onBackEvent}
                    data-testid={GROUP_CART_ORDER_DATA_TEST_IDS.GO_BACK_CTA}
                >
                    {GO_BACK_CTA_TEXT}
                </FullWidthButton>
            </GroupCartBottomSheetContainer>
        </HalfCard>
    );
};

export default React.memo(GroupCartBottomSheetInfo);
